<template>
  <div class="section level">
    <span class="level-item" />
    <div class="level-item box sign-in-card">
      <div class="content">
        <p class="title is-4">Sign In</p>

        <!-- Sign in error notification section -->
        <div class="notification is-danger" v-if="signInError">
          {{ signInError }}
        </div>

        <form v-on:submit.prevent="signIn">
          <div class="field">
            <div class="control has-icons-left">
              <input
                class="input"
                type="text"
                placeholder="Email"
                v-model="email"
                :disabled="isSigningIn"
              />
              <span class="icon is-small is-left">
                <i class="icon-user"></i>
              </span>
            </div>
          </div>

          <div class="field">
            <div class="control has-icons-left">
              <input
                class="input"
                type="password"
                placeholder="Password"
                v-model="password"
                :disabled="isSigningIn"
              />
              <span class="icon is-small is-left">
                <i class="icon-lock"></i>
              </span>
            </div>
          </div>

          <div class="field">
            <div class="control">
              <button
                class="button is-primary is-pulled-right"
                :disabled="isSigningIn"
                :class="{'is-loading': isSigningIn}"
              >Sign in</button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <span class="level-item" />
  </div>
</template>

<script>
import api from "@/api/api.js";
import session from '@/api/session.js'

export default {
  name: "SignIn",

  data() {
    return {
      email: undefined,
      password: undefined,
      isSigningIn: false,
      signInError: undefined
    };
  },

  methods: {
    signIn() {
      if (!this.email || this.email.length == 0) {
        return;
      }
      if (!this.password || this.password.length == 0) {
        return;
      }

      this.signInError = undefined;
      this.isSigningIn = true;

      api
        .post('admin/authentication', { email: this.email, password: this.password })
        .then(response => {
          const token = response.data.token;

          if (!token) {
            this.signInError = 'Sign in failed';
            return;
          }

          session.setSession(token, response.data.user);
          this.$router.replace({ name: 'search' });
        })
        .catch(error => {
          this.signInError = error || 'Sign in failed';
        })
        .finally(() => (this.isSigningIn = false));
    }
  }
};
</script>

<style lang="scss" scoped>
.sign-in-card {
  max-width: 400px;

  .content {
    width: 100%;
  }
}
</style>
